function transformStringToJDM(input) {
  const modifiedString = input.replace(/\s+/g, "-") + "-JDM";
  return modifiedString;
}

export { transformStringToJDM };
